import { ScheduleType } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-type.enum';
import { CartItem } from '@/types/cart.types';

export function isFlexCartItem(item: CartItem): boolean {
  return item.slot.scheduleType === ScheduleType.FLEX;
}
